import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import TestApp from './TestApp';
import './index.css';
import { VERSION } from './version';

console.log('main.tsx loading...');
console.log('App version:', VERSION);

// Register service worker for cache invalidation
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Registered:', registration.scope);

        // Check for updates every 5 minutes
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);
      })
      .catch((error) => {
        console.warn('[SW] Registration failed:', error);
      });
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
  document.body.innerHTML = '<h1>Error: Root element not found!</h1>';
} else {
  console.log('Rendering React app...');
  try {
    // Check if we're hydrating SSR content or doing initial client render
    if (rootElement.hasChildNodes()) {
      // SSR: Hydrate existing pre-rendered HTML
      console.log('Hydrating SSR content...');
      ReactDOM.hydrateRoot(
        rootElement,
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      );
      console.log('SSR hydration complete');
    } else {
      // Fallback: Client-only render (development mode without SSR)
      console.log('Client-side rendering (no SSR)...');
      ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      );
      console.log('React app rendered successfully');
    }
  } catch (error) {
    console.error('Error rendering React app:', error);
    rootElement.innerHTML = `<h1>Error rendering app: ${error}</h1>`;
  }
}